export default {"src":"/_next/static/media/student-loan-refinance.d2954ede.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};